import { type ReactNode, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createAppQueryClient } from './queryClient.js';

export interface AppQueryProviderProps {
  children: ReactNode;
}

/** TanStack Query provider — one QueryClient instance per app shell. */
export function AppQueryProvider({ children }: AppQueryProviderProps) {
  const [client] = useState(() => createAppQueryClient());
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
